import React from "react";
import { ProductsTableImageColumnProps } from "./products-table-image-column.props";
import { ProductImageCell } from "./products-table-image-column.styles";
import { ProductImage } from "../product-image/product-image.component";

export const ProductsTableImageColumn = (props: ProductsTableImageColumnProps) => (
  <ProductImageCell>
    <ProductImage imageUrl={props.product.productDetail.image} title={props.product.productDetail.name} />
  </ProductImageCell>
);
